import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { AuthGuard } from '../app-route-guards';

import { SignUpComponent } from './sign-up/sign-up.component';
import { DoNotMailComponent } from './do-not-mail/do-not-mail.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsTemplateComponent } from './terms-and-conditions-template/terms-and-conditions-template.component';
import { UserRoleChangePanelComponent } from './user-role-change-panel/user-role-change-panel.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'login/:loginType', component: LoginComponent, pathMatch: 'full' },
  { path: 'login/:loginType/:uuid/:token/:username', component: LoginComponent, pathMatch: 'full' },
  { path: 'signup', component: SignUpComponent, pathMatch: 'full' },
  { path: 'terms', component: TermsAndConditionsTemplateComponent, pathMatch: 'full' },
  { path: 'dnm', component: DoNotMailComponent, pathMatch: 'full' },
  { path: 'contact-us', component: ContactUsComponent, pathMatch: 'full' },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, pathMatch: 'full' },
  { path: 'terms-and-conditions', component: TermsConditionsComponent, pathMatch: 'full' },
  { path: 'user-role', component: UserRoleChangePanelComponent, pathMatch: 'full', canActivate: [AuthGuard]},
  { path: 'onboarding', loadChildren: () => import('../onboarding/onboarding.module').then(m => m.OnboardingModule) },
  { path: 'investor', loadChildren: () => import('../investor/investor.module').then(m => m.InvestorModule) },
  { path: 'issuer', loadChildren: () => import('../issuer/issuer.module').then(m => m.IssuerModule) },
  { path: 'ipa', loadChildren: () => import('../ipa/ipa.module').then(m => m.IpaModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})

export class CoreRoutingModule { }
